import { IconV2 } from 'components/common/IconV2/IconV2';
import type { SmallIconV2Props } from 'components/common/IconV2/IconV2.types';

const MinusSmallIcon = (props: SmallIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 16 16">
    <path stroke="currentcolor" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M2.274 7.833H14.06h-1.767" />
  </IconV2>
);

export default MinusSmallIcon;
